<template>
  <div class="borrowerAttributeBoolean">
    <div>
      <label :for="'ba' + question.id" class="mb-3 ba-label existing-loans">
        {{ label }}
        <LendioBootstrapTooltip v-if="tooltipText">
            <span class="text-tooltip-icon blue-300" data-bs-toggle="tooltip" data-bs-placement="right" :title="tooltipText">
              <i class="fa-light fa-circle-info"></i>
            </span>
        </LendioBootstrapTooltip>
      </label>
      <BorrowerAttributeConstructor
        :questionText="questionText"
        :description="description"
        :descriptionTooltip="descriptionTooltip"
        :errorText="errorText"
        :helpText="helpText"
        :disclaimer="disclaimer">
        <template v-slot:input>
          <div class="form-check d-inline-block checkBox pe-2" v-for="option in options"
              :key="option.value">
            <input type="radio"
                    :id="'ba' + question.id + '-' + option.value"
                    class="form-check-input"
                    :name="'ba' + question.id"
                    :data-cy="question.alias"
                    :data-cy-bool="question.alias + '-' + option.value"
                    v-model="value"
                    :value="option.value"
                    :disabled="disabled"
                    @change="onBlur(v$.value, $event)"
            >
            <label class="form-check-label" :for="'ba' + question.id + '-' + option.value">{{option.label}}</label>
          </div>
        </template>
      </BorrowerAttributeConstructor>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import get from 'lodash/get'
import BaseBorrowerAttributeMixin from './BaseBorrowerAttributeMixin'

export default {
  emits: ['invalidity','answer'],
  setup: () => ({ v$: useVuelidate() }),
  data () {
    return {
      errorMessage: 'Please select an answer'
    }
  },
  props: {
    disabled: Boolean
  },
  created () {
    this.$watch('invalid', (invalid) => {
      this.$emit('invalidity', invalid)
    }, {immediate: true})
  },
  computed: {
    invalid() {
      return this.v$.$invalid
    },
    options() {
      return this.question.options || [
        { label: 'Yes', value: '1' },
        { label: 'No', value: '0' }
      ]
    },
    // element computed fields
    errorText() {
      return get(this.v$, 'value.$error') ? this.errorMessage : ''
    },
  },
  methods: {
    onBlur (v$, e) {
      v$.$touch()
      this.$emit('invalidity', v$.$invalid)
      this.$emit('answer', { value: e.target.value, isInvalid: v$.$error })
    }
  },
  mixins: [BaseBorrowerAttributeMixin],
  validations: function () {
    return {
      value: { required }
    }
  }
}
</script>

<style lang="scss" scoped>

.borrowerAttributeBoolean {
  width: 600px;
  @include media-breakpoint-down(lg) {
   width: 350px;
  }
}

.checkBox {
  @include media-breakpoint-up(lg) {
    width: 10%;
  }
}

.existing-loans {
   @include media-breakpoint-down(lg) {
    max-width: 325px;
  }
}

</style>
